<assignments-dashboard
  *ngIf="shouldShowDashboard"
  [assignmentsTabAccounts]="assignmentsTabAccounts"
  [simulationsTabAccounts]="simulationsTabAccounts"
></assignments-dashboard>

<div class="container" *ngIf="shouldShowNoAccess()">
  <p>
    This user has not been set up with access to the simulation builder. Please
    contact a system administrator.
  </p>
</div>
